import {ChosenProductCategoryWatcher} from './ChosenProductCategoryWatcher.js';

export class ProductVariableSet {
	constructor(setEl) {
		this.setEl = setEl;
		this.categories = JSON.parse(this.setEl.getAttribute(`data-terrahub-product-categories`)).filter(r => r);
		if (0==this.categories.length) {
			return;
		}
		document.addEventListener(`terrahub-product-category-set`, evt=>{
			const method = this.categories.includes(evt.detail.product_category_id) ? 'remove' : 'add';
			this.setEl.classList[method]('terrahub-hide')
		});
	}
	static init() {
		for (const el of document.querySelectorAll(`div.dokan-form-group.terrahub-variableset`)) {
			new ProductVariableSet(el);
		}
		// Only construct the watcher _after_ the ProductVariableSet's so that 
		// on first instance each PVS will receive an update.
		new ChosenProductCategoryWatcher();
	}
}